import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';
import { keyframes } from '@mui/system';
const float = keyframes`
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(0px);
  }
`;

const ConversationSection = () => {
  return (
    <Box
      sx={{
        py: { xs: 6, md: 6 },
        px: { xs: 2, md: 6 },
        maxWidth: 1200,
        my:4,
        bgcolor:"#FFF",
          borderRadius:6,
          border:"1px solid #E0E0E0",
        // bgcolor: '#F8F0FF',
        position: 'relative',
        overflow: 'hidden',
        boxShadow:"0px 0px 20px 20px rgba(0, 0, 0, 0.1)"
      }}
    >
      <Container 
        maxWidth="lg"
        sx={{
          position: 'relative',
      
        }}
      >
        <Grid container spacing={6} alignItems="center">
          <Grid item xs={12} md={5}>
            <Box sx={{ maxWidth: 480 }}>
              <Typography
                variant="h2"
                component="h2"
                sx={{
                  fontSize: { xs: '30px', md: '50px' },
                  fontWeight: 600,
                  mb: 3,
                  lineHeight: 1.2,
                  letterSpacing:-1.8,
                  color:"#4728c4",
                }}
              >
                Capture the conversation.
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: '16px', md: '18px' },
                  color: '#4D4D4D',
                  lineHeight: 1.6,
                }}
              >
          Dive deep into the topics are trending across posts, campaigns, creators, brands, and competitors.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={7}>
          <Box 
                sx={{ 
                  position: 'relative', 
                  zIndex: 1, 
                  display: 'flex', 
                  justifyContent: 'center', 
                  alignItems: 'center',
                  mb: {xs: -10, sm: -14, md: -14},
                  '@keyframes float': {
                    '0%': {
                      transform: 'translateY(0px)'
                    },
                    '50%': {
                      transform: 'translateY(-10px)'
                    },
                    '100%': {
                      transform: 'translateY(0px)'
                    }
                  },
                  animation: 'float 4s ease-in-out infinite'
                }}
              >
               <img src={`./conversation.png`} style={{width:"80%"}}/>

</Box>

              

          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default ConversationSection; 